import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { PencilIcon, SearchIcon, XIcon } from '@primer/octicons-react'
import { BiPlus, BiCategoryAlt, BiLink, BiPencil, BiSearch, BiSitemap, BiTrash, BiX } from "react-icons/bi";
import { axiosAuth_PLATFORM_API, axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { testJSON, isNaturalNumber } from '../utils/jsUtils';


const UiAppAdminDetailsView = (props) => {


  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [uiAppAttrs, setUiAppAttrs] = useState({
    id: '',
    name: '',
    description: '',
    interface: '',
    product: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [origUiAppAttrs, setOrigUiAppAttrs] = useState({});


  // -- View vs Edit Modes --
  const [editModeGeneralInfo, setEditModeGeneralInfo] = useState(false);

  const [errMsg,              setErrMsg]               = useState('');
  const [errMsg_GenInfo,      setErrMsg_GenInfo]       = useState('');

  // -- Sitemap vs Element Modes --
  const [tabMode, setTabMode] = useState('ELEMENTS_TAB');

  const handleTargetToggle = (tab, e) => {
    setTabMode(tab);

    if ((tab === 'SITEMAP_TAB') && (uiAppAttrs.id !== '')) {
      fetchSitemap (uiAppAttrs);
    }
  }


  // -- Sitemap Tree Related --
  const [screenList,     setScreenList]      = useState([]);
  const [sectionList,    setSectionList]     = useState([]);
  const [elementList,    setElementList]     = useState([]);

  const [parentMenuList, setParentMenuList]  = useState([]);

  // --- Permission that controls the screen ---
  const [permList,             setPermList]             = useState([]);
  const [showPermPickerDialog, setShowPermPickerDialog] = useState(false);
  const [permPickerErrMsg,     setPermPickerErrMsg]     = useState('');
  const [permPickerMode,       setPermPickerMode]       = useState('');


  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const columnsScreens = [
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      width: '200px',
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleScreenSelect(row)}>{row.name}</span>
      )
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      width: '150px',
      wrap: true
    },
    {
      name: t("I18N_Path"),
      selector: row => row.path,
      width: '200px',
      wrap: true
    },
    {
      name: t("I18N_Parent_menu"),
      selector: row => row.parentName,
      width: '100px',
      wrap: true
    },
    {
      name: t("I18N_Show_3d_model"),
      selector: row => row.show3dModel,
      cell: row => (
        row.show3dModel  === 1 ? <span>&#10003;</span> : ''
      ),
      grow: 0.5
    },
    {
      name: t("I18N_Show_scope_sel"),
      selector: row => row.showScopeSel,
      cell: row => (
        row.showScopeSel  === 1 ? <span>&#10003;</span> : ''
      ),
      grow: 0.5
    },
    {
      name: t("I18N_Show_playback"),
      selector: row => row.showPlayback,
      cell: row => (
        row.showPlayback  === 1 ? <span>&#10003;</span> : ''
      ),
      grow: 0.5
    },
    {
      name: t("I18N_Order_num"),
      selector: row => row.orderNum,
      width: '80px'
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      grow: 0.5,
      cell: row => (
        t("I18N_" + row.status)
      )
    },
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        <div style={{display:'flex'}}>
        <OverlayTrigger overlay={<Tooltip id="tooltip-edit-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_screen")}</Tooltip>}>
          <span style={{cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleScreenEdit(row)}><BiPencil size={16} />
          </span>
        </OverlayTrigger>
        <OverlayTrigger overlay={<Tooltip id="tooltip-remove-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_screen")}</Tooltip>}>
          <span style={{marginLeft:'5px', cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleScreenDelete(row)}><BiTrash size={16} />
          </span>
        </OverlayTrigger>
        </div>
      )
    }
  ];

  const columnsSections = [
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      grow: 2,
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleSectionSelect(row)}>{row.name}</span>
      )
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 9,
      wrap: true
    },
    {
      name: t("I18N_Order_num"),
      selector: row => row.orderNum
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      cell: row => (
        t("I18N_" + row.status)
      )
    },
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        <div style={{display:'flex'}}>
        <OverlayTrigger overlay={<Tooltip id="tooltip-edit-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_section")}</Tooltip>}>
          <span style={{cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleSectionEdit(row)}><BiPencil size={16} />
          </span>
        </OverlayTrigger>
        <OverlayTrigger overlay={<Tooltip id="tooltip-remove-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_section")}</Tooltip>}>
          <span style={{marginLeft:'5px', cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleSectionDelete(row)}><BiTrash size={16} />
          </span>
        </OverlayTrigger>
        </div>
      )
    }
  ];

  const columnsElements = [
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleElementEdit(row)}>{row.name}</span>
      ),
      grow: 2,
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 4,
      wrap: true
    },
    {
      name: t("I18N_UiComp"),
      selector: row => row.compName,
      grow: 5,
    },
    {
      name: t("I18N_Order_num"),
      selector: row => row.orderNum
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      cell: row => (
        t("I18N_" + row.status)
      )
    },
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        <div style={{display:'flex'}}>
        <OverlayTrigger overlay={<Tooltip id="tooltip-edit-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_element")}</Tooltip>}>
          <span style={{cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleElementEdit(row)}><BiPencil size={16} />
          </span>
        </OverlayTrigger>
        <OverlayTrigger overlay={<Tooltip id="tooltip-remove-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_element")}</Tooltip>}>
          <span style={{marginLeft:'5px', cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleElementDelete(row)}><BiTrash size={16} />
          </span>
        </OverlayTrigger>
        </div>
      )
    }
  ];


  // ===== Ui App =====

  // ##### Enhancement: Fetch through API or config. #####

  const interfaceOptions = [
    { key: "WEB",    value: "WEB" },
    { key: "MOBILE", value: "MOBILE" }
  ];


  // ===== Sitemap =====

  //const [sitemap,        setSitemap]        = useState({});   // Currently sitemap is not used, but maybe later
  const [sitemapDisplay, setSitemapDisplay] = useState('');

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];

  // ===== Screen =====

  const initScreen = {
    name: '',
    description: '',
    path: '',
    appId: '',
    parentId: '',
    show3dModel: 0,
    showScopeSel: 0,
    showPlayback: 0,
    floorListDisplay: JSON.stringify(JSON.parse(JSON.stringify([])), undefined, 4),
    layerListDisplay: JSON.stringify(JSON.parse(JSON.stringify([])), undefined, 4),
    orderNum: '',
    permCode: '',
    permId: null,
    status: ''
  };

  const [selectedScreen,         setSelectedScreen]         = useState(null);
  const [newScreen,              setNewScreen]              = useState(initScreen);
  const [targetScreen,           setTargetScreen]           = useState(null);

  const [showScreenAddDialog,    setShowScreenAddDialog]    = useState(false);
  const [showScreenEditDialog,   setShowScreenEditDialog]   = useState(false);
  const [showScreenDeleteDialog, setShowScreenDeleteDialog] = useState(false);

  const [errMsg_ScreenAdd,       setErrMsg_ScreenAdd]       = useState('');
  const [errMsg_ScreenEdit,      setErrMsg_ScreenEdit]      = useState('');
  const [errMsg_ScreenDelete,    setErrMsg_ScreenDelete]    = useState('');

  // --- Screen Select ---

  function handleScreenSelect(screen) {

    setSectionList([]);
    setElementList([]);
    setSelectedSection(null);
    setSelectedScreen(screen);

    fetchSections(screen.id);
  }

  // --- Screen Add ---

  function handleScreenAdd() {
    setErrMsg_ScreenAdd('');
    setShowScreenAddDialog(true);
  }

  const onScreenAddInputChange = (e) => {
    setNewScreen({ ...newScreen, [e.target.name]: e.target.value });
  }

  const onAddParentSelect = (key, event) => {
    let tmp = JSON.parse(JSON.stringify(newScreen));

    tmp.parentId   = key;
    tmp.parentName = key ? (screenList.find(({ id }) => id.toString() === key)).name : "";

    setNewScreen(tmp);
  };

  const onCheckboxSelectNew = (e) => {
    setNewScreen({ ...newScreen, [e.target.name]: (e.target.checked ? 1 : 0) });
  }

  const onStatusSelectScreenNew = (key, event) => {
    setNewScreen({ ...newScreen, status: key });
  };

  function handleScreenAddCancel() {
    setNewScreen(initScreen);
    setErrMsg_ScreenAdd('');
    setShowScreenAddDialog(false);
  }

  function handleScreenAddSubmit(e) {
    e.preventDefault();

    if (!newScreen || !newScreen.name || newScreen.name.length === 0) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Need_screen_name"));
      return;
    } else if (newScreen.name.length > 100) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_name") + 100);
      return;
    } else if (!newScreen.description || newScreen.description.length === 0) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Need_description"));
      return;
    } else if (newScreen.description.length > 250) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (   (newScreen.parentId && (newScreen.parentId.length > 0))
               && (!newScreen.path || newScreen.path.length === 0)) {
      // Sometimes, top level is just a container and does not require a path
      setErrMsg_ScreenAdd(t("I18N_ERR_Need_path"));
      return;
    } else if (newScreen.path.length > 100) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_path") + 100);
      return;
    } else if (!newScreen.orderNum || newScreen.orderNum.length === 0) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(newScreen.orderNum))
               || (parseInt(newScreen.orderNum) > 1000000)) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!newScreen.status || newScreen.status.length === 0) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Need_status"));
      return;
    } else if (   (newScreen.floorListDisplay !== '')
               && (!testJSON(newScreen.floorListDisplay))) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Floor_list_invalid_JSON"));
    } else if (   (newScreen.layerListDisplay !== '')
               && (!testJSON(newScreen.layerListDisplay))) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Layer_list_invalid_JSON"));
    }

    // Convert back JSON attributes
    if (newScreen.floorListDisplay !== '')
      newScreen.floorList = JSON.parse(newScreen.floorListDisplay);

    if (newScreen.layerListDisplay !== '')
      newScreen.layerList = JSON.parse(newScreen.layerListDisplay);

    newScreen.appId = uiAppAttrs.id;

    let reqBody = newScreen;

    // Convert show settings

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-screens", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          setShowScreenAddDialog(false);
          setNewScreen(initScreen);
          setErrMsg_ScreenAdd('');
          fetchScreens(uiAppAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ScreenAdd(t(translateAPIError(error)));
        }
      }
    });
  }

  // --- Screen Edit ---

  function handleScreenEdit(screen) {
    setTargetScreen(screen);
    setErrMsg_ScreenEdit('');
    setShowScreenEditDialog(true);
  }

  const onScreenEditInputChange = (e) => {
    setTargetScreen({ ...targetScreen, [e.target.name]: e.target.value });
  }

  const onEditParentSelect = (key, event) => {
/* ##### The first setTargetScreen() does not take effect!  Need to understand why #####
    setTargetScreen({ ...targetScreen, parentId:   key });
    setTargetScreen({ ...targetScreen, parentName: (screenList.find(({ id }) => id == key)).name });
*/
    let tmp = JSON.parse(JSON.stringify(targetScreen));

    tmp.parentId   = key;
    tmp.parentName = key ? (screenList.find(({ id }) => id.toString() === key)).name : "";

    setTargetScreen(tmp);
  };

  const onCheckboxSelectEdit = (e) => {
    setTargetScreen({ ...targetScreen, [e.target.name]: (e.target.checked ? 1 : 0) });
  }

  const onStatusSelectScreenEdit = (key, event) => {
    setTargetScreen({ ...targetScreen, status: key });
  };

  function handleScreenEditCancel() {
    setTargetScreen(null);
    setErrMsg_ScreenEdit('');
    setShowScreenEditDialog(false);
  }

  function handleScreenEditSubmit(e) {
    e.preventDefault();

    if (!targetScreen || !targetScreen.name || targetScreen.name.length === 0) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Need_screen_name"));
      return;
    } else if (targetScreen.name.length > 100) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_name") + 100);
      return;
    } else if (!targetScreen.description || targetScreen.description.length === 0) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Need_description"));
      return;
    } else if (targetScreen.description.length > 250) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (   (targetScreen.parentId && (targetScreen.parentId.length > 0))
               && (!targetScreen.path || targetScreen.path.length === 0)) {
      // Sometimes, top level is just a container and does not require a path
      setErrMsg_ScreenEdit(t("I18N_ERR_Need_path"));
      return;
    } else if (targetScreen.path.length > 100) {
      setErrMsg_ScreenAdd(t("I18N_ERR_Max_len_path") + 100);
      return;
    } else if (!targetScreen.orderNum || targetScreen.orderNum.length === 0) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(targetScreen.orderNum))
               || (parseInt(targetScreen.orderNum) > 1000000)) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!Number.isInteger(Number(targetScreen.orderNum))) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!targetScreen.status || targetScreen.status.length === 0) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Need_status"));
      return;
    } else if (   (targetScreen.floorListDisplay !== '')
               && (!testJSON(targetScreen.floorListDisplay))) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Floor_list_invalid_JSON"));
      return;
    } else if (   (targetScreen.layerListDisplay !== '')
               && (!testJSON(targetScreen.layerListDisplay))) {
      setErrMsg_ScreenEdit(t("I18N_ERR_Layer_list_invalid_JSON"));
      return;
    }

    // Convert back JSON attributes
    if (targetScreen.floorListDisplay !== '') {
      targetScreen.floorList = JSON.parse(targetScreen.floorListDisplay);
    }

    if (targetScreen.layerListDisplay !== '') {
      targetScreen.layerList = JSON.parse(targetScreen.layerListDisplay);
    }

    let reqBody = targetScreen;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("ui-screens/" + targetScreen.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setShowScreenEditDialog(false);
          setErrMsg_ScreenEdit('');
          fetchScreens(uiAppAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ScreenEdit(t(translateAPIError(error)));
        }
      }
    });

  }


  // --- Screen Delete ---

  function handleScreenDelete(screen) {
    setTargetScreen(screen);
    setShowScreenDeleteDialog(true);
  }

  function handleScreenDeleteCancel() {
    setTargetScreen(null);
    setErrMsg_ScreenDelete('');
    setShowScreenDeleteDialog(false);
  }

  function handleScreenDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.delete("ui-screens/" + targetScreen.id);

        resolve(res.data);

        if (res.status === 200) {
          setShowScreenDeleteDialog(false);
          setErrMsg_ScreenDelete('');
          fetchScreens(uiAppAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ScreenDelete(t(translateAPIError(error)));
        }
      }
    });
  }

  // --- Screen Utilities ---

  const handlePermPicker = (e, mode) => {
    setPermPickerMode(mode);
    setPermPickerErrMsg('');
    setShowPermPickerDialog(true);
  }

  const handleClearPermPicker = (e, mode) => {

    // Deep copy
    let tmpScreenAttrs;

    if (mode === 'NEW') {
      tmpScreenAttrs = JSON.parse (JSON.stringify(newScreen));
    } else if (mode === 'EDIT') {
      tmpScreenAttrs = JSON.parse (JSON.stringify(targetScreen));
    }

    tmpScreenAttrs.permId   = null;
    tmpScreenAttrs.permCode = '';

    if (mode === 'NEW') {
      setNewScreen(tmpScreenAttrs);
    } else if (mode === 'EDIT') {
      setTargetScreen(tmpScreenAttrs);
    }
  }


  function handlePermPickerClose() {
    setShowPermPickerDialog(false);
  }

  function handlePermPickerSubmit(perm) {
    // Deep copy
    let tmpScreenAttrs;

    if (permPickerMode === 'NEW') {
      tmpScreenAttrs = JSON.parse (JSON.stringify(newScreen));
    } else if (permPickerMode === 'EDIT') {
      tmpScreenAttrs = JSON.parse (JSON.stringify(targetScreen));
    }

    tmpScreenAttrs.permId   = perm.id;
    tmpScreenAttrs.permCode = perm.nameCode;

    if (permPickerMode === 'NEW') {
      setNewScreen(tmpScreenAttrs);
    } else if (permPickerMode === 'EDIT') {
      setTargetScreen(tmpScreenAttrs);
    }

    setShowPermPickerDialog(false);
  }

  function renderPermPicker(perm, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{(t("custom:I18N_" + perm.nameCode) === ("I18N_" + perm.nameCode)) ?
              perm.nameCode : t("custom:I18N_" + perm.nameCode)}</td>
        <td>{perm.description}</td>
        <td>
          <span>
            <Button size="tiny" variant="outline-secondary"
              style={{ float: 'left' }}
              onClick={(e) => {handlePermPickerSubmit(perm)}}>
              {t("I18N_Add")}
            </Button>
          </span>
        </td>
      </tr>
    )
  }


  // ===== Section =====

  const initSection = {
    name: '',
    description: '',
    screenId: '',
    orderNum: '',
    status: ''
  };

  const [selectedSection,         setSelectedSection]         = useState(null);

  const [newSection,              setNewSection]              = useState(initSection);
  const [targetSection,           setTargetSection]           = useState(null);

  const [showSectionAddDialog,    setShowSectionAddDialog]    = useState(false);
  const [showSectionEditDialog,   setShowSectionEditDialog]   = useState(false);
  const [showSectionDeleteDialog, setShowSectionDeleteDialog] = useState(false);

  const [errMsg_SectionAdd,       setErrMsg_SectionAdd]       = useState('');
  const [errMsg_SectionEdit,      setErrMsg_SectionEdit]      = useState('');
  const [errMsg_SectionDelete,    setErrMsg_SectionDelete]    = useState('');

  // --- Section Select ---

  function handleSectionSelect(section) {
    setSelectedSection(section);
    fetchElements(section.id);
  }

  // --- Section Add ---

  function handleSectionAdd() {
    setErrMsg_SectionAdd('');
    setShowSectionAddDialog(true);
  }

  const onSectionAddInputChange = (e) => {
    setNewSection({ ...newSection, [e.target.name]: e.target.value });
  }

  const onStatusSelectSectionNew = (key, event) => {
    setNewSection({ ...newSection, status: key });
  };

  function handleSectionAddCancel() {
    setNewSection({ name: '',
                    desription: ''});
    setErrMsg_SectionAdd('');
    setShowSectionAddDialog(false);
  }

  function handleSectionAddSubmit(e) {
    e.preventDefault();

    if (!newSection || !newSection.name || newSection.name.length === 0) {
      setErrMsg_SectionAdd(t("I18N_ERR_Need_section_name"));
      return;
    } else if (!newSection.description || newSection.description.length === 0) {
      setErrMsg_SectionAdd(t("I18N_ERR_Need_description"));
      return;
    } else if (!newSection.orderNum || newSection.orderNum.length === 0) {
      setErrMsg_SectionAdd(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(newSection.orderNum))
               || (parseInt(newSection.orderNum) > 1000000)) {
      setErrMsg_SectionAdd(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!Number.isInteger(Number(newSection.orderNum))) {
      setErrMsg_SectionAdd(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!newSection.status || newSection.status.length === 0) {
      setErrMsg_SectionAdd(t("I18N_ERR_Need_status"));
      return;
    }

    newSection.screenId = selectedScreen.id;

    let reqBody = newSection;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-sections", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          setShowSectionAddDialog(false);
          setNewSection(initSection);
          setErrMsg_SectionAdd('');
          fetchSections(selectedScreen.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_SectionAdd(t(translateAPIError(error)));
        }
      }
    });
  }

  // --- Section Edit ---

  function handleSectionEdit(section) {
    setTargetSection(section);
    setErrMsg_SectionEdit('');
    setShowSectionEditDialog(true);
  }

  const onSectionEditInputChange = (e) => {
    setTargetSection({ ...targetSection, [e.target.name]: e.target.value });
  }

  const onStatusSelectSectionEdit = (key, event) => {
    setTargetSection({ ...targetSection, status: key });
  };

  function handleSectionEditCancel() {
    setTargetSection(null);
    setErrMsg_SectionEdit('');
    setShowSectionEditDialog(false);
  }

  function handleSectionEditSubmit(e) {
    e.preventDefault();

    if (!targetSection || !targetSection.name || targetSection.name.length === 0) {
      setErrMsg_SectionEdit(t("I18N_ERR_Need_section_name"));
      return;
    } else if (!targetSection.description || targetSection.description.length === 0) {
      setErrMsg_SectionEdit(t("I18N_ERR_Need_description"));
      return;
    } else if (!targetSection.orderNum || targetSection.orderNum.length === 0) {
      setErrMsg_SectionEdit(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(targetSection.orderNum))
               || (parseInt(targetSection.orderNum) > 1000000)) {
      setErrMsg_SectionEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!Number.isInteger(Number(targetSection.orderNum))) {
      setErrMsg_SectionEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!targetSection.status || targetSection.status.length === 0) {
      setErrMsg_SectionEdit(t("I18N_ERR_Need_status"));
      return;
    }

    let reqBody = targetSection;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("ui-sections/" + targetSection.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setShowSectionEditDialog(false);
          setErrMsg_SectionEdit('');
          fetchSections(selectedScreen.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_SectionEdit(t(translateAPIError(error)));
        }
      }
    });

  }


  // --- Section Delete ---

  function handleSectionDelete(section) {
    setTargetSection(section);
    setShowSectionDeleteDialog(true);
  }

  function handleSectionDeleteCancel() {
    setTargetSection(null);
    setErrMsg_SectionDelete('');
    setShowSectionDeleteDialog(false);
  }

  function handleSectionDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.delete("ui-sections/" + targetSection.id);

        resolve(res.data);

        if (res.status === 200) {
          setShowSectionDeleteDialog(false);
          setErrMsg_SectionDelete('');
          fetchSections(selectedScreen.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_SectionDelete(t(translateAPIError(error)));
        }
      }
    });
  }


  // ===== Element =====

  const initElement = {
    name: '',
    description: '',
    sectionId: '',
    compId: '',
    compName: '',
    compConfigDisplay: JSON.stringify(JSON.parse(JSON.stringify({})), undefined, 4),
    orderNum: '',
    status: ''
  };

  const [newElement,              setNewElement]              = useState(initElement);
  const [targetElement,           setTargetElement]           = useState(null);

  const [showElementAddDialog,    setShowElementAddDialog]    = useState(false);
  const [showElementEditDialog,   setShowElementEditDialog]   = useState(false);
  const [showElementDeleteDialog, setShowElementDeleteDialog] = useState(false);

  const [errMsg_ElementAddOrEdit, setErrMsg_ElementAddOrEdit] = useState('');
  const [errMsg_ElementDelete,    setErrMsg_ElementDelete]    = useState('');

  const [compList,                setCompList]                = useState(true);
  const [compShowSelector,        setShowCompSelector]        = useState(false);


  // --- Element Add ---

  function handleElementAdd() {
    setErrMsg_ElementAddOrEdit('');
    setShowElementAddDialog(true);
  }

  const onElementAddInputChange = (e) => {
    setNewElement({ ...newElement, [e.target.name]: e.target.value });
  }

  const onStatusSelectElementNew = (key, event) => {
    setNewElement({ ...newElement, status: key });
  };

  function handleElementAddCancel() {
    setNewElement(initElement);
    setErrMsg_ElementAddOrEdit('');
    setShowElementAddDialog(false);
    setShowElementEditDialog(false);
  }

  function handleElementAddSubmit(e) {
    e.preventDefault();

    if (!newElement || !newElement.name || newElement.name.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_element_name"));
      return;
    } else if (!newElement.description || newElement.description.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_description"));
      return;
    } else if (!newElement.compId || newElement.compId.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_comp"));
      return;
    } else if (   (newElement.compConfigDisplay !== '')
               && (!testJSON(newElement.compConfigDisplay))) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Comp_config_invalid_JSON"));
      return;
    } else if (!newElement.orderNum || newElement.orderNum.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(newElement.orderNum))
               || (parseInt(newElement.orderNum) > 1000000)) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!Number.isInteger(Number(newElement.orderNum))) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!newElement.status || newElement.status.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_status"));
      return;
    }

    newElement.sectionId = selectedSection.id;

    // Convert back JSON attributes
    if (newElement.compConfigDisplay !== '')
      newElement.compConfig = JSON.parse(newElement.compConfigDisplay);

    let reqBody = newElement;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("ui-elements", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          setShowElementAddDialog(false);
          setNewElement({});
          setErrMsg_ElementAddOrEdit('');
          fetchElements(selectedSection.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ElementAddOrEdit(t(translateAPIError(error)));
        }
      }
    });
  }

  function handleSearchCompSubmit(e) {
    e.preventDefault();

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-comps?searchTerms=" + searchTerm);

        resolve(res.data);

        if (res.status === 200) {
          setCompList(res.data.data);
        }

        setErrMsg_ElementAddOrEdit('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ElementAddOrEdit(t(translateAPIError(error)));
        }
      }
    });
  }

  function handleCompSelect(comp) {

    let temp;
    if (showElementAddDialog) {
      temp = JSON.parse (JSON.stringify(newElement));
    } else {
      temp = JSON.parse (JSON.stringify(targetElement));
    }

    temp.compDesc = comp.description;
    temp.compName = comp.name;
    temp.compId = comp.id;


    if (showElementAddDialog) {
      setNewElement(temp);
    } else {
      setTargetElement(temp);
    }

    setShowCompSelector(false);
  }

  function handleCompSearchOpen() {
    setShowCompSelector(true);
  }

  function handleCompSearchClose() {
    setShowCompSelector(false);
  }

  // --- Element Edit ---

  function handleElementEdit(element) {
    setTargetElement(element);
    setErrMsg_ElementAddOrEdit('');
    setShowElementEditDialog(true);
  }

  const onElementEditInputChange = (e) => {
    setTargetElement({ ...targetElement, [e.target.name]: e.target.value });
  }

  const onStatusSelectElementEdit = (key, event) => {
    setTargetElement({ ...targetElement, status: key });
  };

  function handleElementEditCancel() {
    setTargetElement(null);
    setErrMsg_ElementAddOrEdit('');
    setShowElementEditDialog(false);
  }

  function handleElementEditSubmit(e) {
    e.preventDefault();

    if (!targetElement || !targetElement.name || targetElement.name.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_element_name"));
      return;
    } else if (!targetElement.description || targetElement.description.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_description"));
      return;
    } else if (!targetElement.compId || targetElement.compId.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_comp"));
      return;
    } else if (   (targetElement.compConfigDisplay !== '')
               && (!testJSON(targetElement.compConfigDisplay))) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Comp_config_invalid_JSON"));
      return;
    } else if (!targetElement.orderNum || targetElement.orderNum.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_order_num"));
      return;
    } else if (   (!isNaturalNumber(targetElement.orderNum))
               || (parseInt(targetElement.orderNum) > 1000000)) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!Number.isInteger(Number(targetElement.orderNum))) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Order_num_valid"));
      return;
    } else if (!targetElement.status || targetElement.status.length === 0) {
      setErrMsg_ElementAddOrEdit(t("I18N_ERR_Need_status"));
      return;
    }

    // Convert back JSON attributes
    if (targetElement.compConfigDisplay !== '')
      targetElement.compConfig = JSON.parse(targetElement.compConfigDisplay);

    let reqBody = targetElement;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("ui-elements/" + targetElement.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setShowElementEditDialog(false);
          setErrMsg_ElementAddOrEdit('');
          fetchElements(selectedSection.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ElementAddOrEdit(t(translateAPIError(error)));
        }
      }
    });

  }


  // --- Element Delete ---

  function handleElementDelete(element) {
    setTargetElement(element);
    setShowElementDeleteDialog(true);
  }

  function handleElementDeleteCancel() {
    setTargetElement(null);
    setErrMsg_ElementDelete('');
    setShowElementDeleteDialog(false);
  }

  function handleElementDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.delete("ui-elements/" + targetElement.id);

        resolve(res.data);

        if (res.status === 200) {
          setShowElementDeleteDialog(false);
          setErrMsg_ElementAddOrEdit('');
          fetchElements(selectedSection.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_ElementAddOrEdit(t(translateAPIError(error)));
        }
      }
    });
  }



  // -- Searching --
  const [newSearchTerm, setSearchTerm] = useState(
    { searchTerm: '' }
  );

  var { searchTerm } = newSearchTerm;

  const onSearchInputChange = (e) => {
    setSearchTerm({ ...searchTerm, [e.target.name]: e.target.value });
  }


  // Ui Functions

  // Initialize status
  useEffect(() => {
    if (props) {
      setUiAppAttrWithFormatting (props.objDetails);

      fetchScreens(props.objDetails.id);

      setNewScreen(initScreen);

      fetchPerms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchPerms = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("permissions");

        resolve(res.data);

        if (res.status === 200) {
          setPermList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
        return;
      }
    });
  }


  const setUiAppAttrWithFormatting = (objDetails) => {
      // Properly format sitemap settings JSON
      // Makes a deep copy
      let tempDetails = JSON.parse (JSON.stringify (objDetails));

      if (objDetails.sitemap && objDetails.sitemap.length > 0) {
        tempDetails.sitemap = JSON.stringify(JSON.parse(objDetails.sitemap), undefined, 4);
        //updateScreenList (tempDetails.sitemap);
      }

      setUiAppAttrs(tempDetails);
      setOrigUiAppAttrs(tempDetails);
  }


  const fetchScreens = (appId) => {

    if (!appId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-screens?appId=" + appId);

        resolve(res.data);

        if (res.status === 200) {

          // Provide a formatted version of the JSON attributes
          for (let i=0; i<res.data.length; i++) {
            res.data[i].floorListDisplay = (res.data[i].floorList === null) ? '{}' :
                                           JSON.stringify(JSON.parse(JSON.stringify(res.data[i].floorList)), undefined, 4);

            res.data[i].layerListDisplay = (res.data[i].layerList === null) ? '{}' :
                                           JSON.stringify(JSON.parse(JSON.stringify(res.data[i].layerList)), undefined, 4);
          }

          setScreenList(res.data);
          let tmp = res.data.filter(function(screen){ return ((screen.parentId === null) && (screen.path === ''));});
          tmp.unshift ({"id": null, "name": "aaa"});  // Dummy node for No Parent

          setParentMenuList(tmp);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const fetchSections = (screenId) => {

    if (!screenId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-sections?screenId=" + screenId);

        resolve(res.data);

        if (res.status === 200) {
          setSectionList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const fetchElements = (sectionId) => {

    if (!sectionId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-elements?sectionId=" + sectionId);

        resolve(res.data);

        if (res.status === 200) {

          // Provide a formatted version of the JSON attributes
          for (let i=0; i<res.data.length; i++) {
            res.data[i].compConfigDisplay = (res.data[i].compConfig === null) ? '{}' :
                                             JSON.stringify(JSON.parse(JSON.stringify(res.data[i].compConfig)), undefined, 4);
          }

          setElementList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const fetchSitemap = (app) => {

    if (!app || !app.id) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-sitemaps/" + app.id);

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {

          let elementArray = res.data;
          let sitemapApp = {
                             appName: app.name,
                             screens: []
                           };

          // Build JSON tree of the sitemap
          for (let i=0; i<elementArray.length; i++) {

            let screenNode = sitemapApp.screens.find(({ screenName }) => screenName === elementArray[i].screenName);

            if (!screenNode) {

              // If a new screen is encountered, add a screen node
              let newScreen = {
                screenName: elementArray[i].screenName,
                path: elementArray[i].path,
                sections: [
                  {
                    sectionName: elementArray[i].sectionName,
                    elements: [
                      {
                        elementName: elementArray[i].elementName,
                        compName:    elementArray[i].compName
                      }
                    ]
                  }
                ]
              };

              sitemapApp.screens.push(newScreen);

            } else {

              let sectionNode = screenNode.sections.find(({ sectionName }) => sectionName === elementArray[i].sectionName);

              if (!sectionNode) {

                // If a new section is encountered, add a section node
                let newSection = {
                  sectionName: elementArray[i].sectionName,
                  elements: [
                    {
                      elementName: elementArray[i].elementName,
                      compName:    elementArray[i].compName
                    }
                  ]
                }

                screenNode.sections.push(newSection);

              } else {

                // If section node already exists, simply add to it
                let newElement =
                      {
                        elementName: elementArray[i].elementName,
                        compName:    elementArray[i].compName
                      }

                sectionNode.elements.push(newElement);
              }
            }
          }

          //setSitemap (sitemapApp);
          setSitemapDisplay (JSON.stringify(sitemapApp, undefined, 4));
        } else if (res.data.length === 0) {
          setSitemapDisplay (t("I18N_App_has_no_elem"));
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditModeGeneralInfo(true);
  }


  const onAttrsInputChange = (e) => {
    setUiAppAttrs({ ...uiAppAttrs, [e.target.name]: e.target.value })
  }

  const onInterfaceSelect = (key, event) => {
    setUiAppAttrs({ ...uiAppAttrs, interface: key })
  };

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setUiAppAttrWithFormatting(origUiAppAttrs);

    setErrMsg_GenInfo('');
    setEditModeGeneralInfo(false);
  }


  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!uiAppAttrs.name || uiAppAttrs.name.trim().length === 0) {
      setErrMsg_GenInfo(t("I18N_ERR_Need_name"));
    } else if (uiAppAttrs.name.length > 100) {
      setErrMsg_GenInfo(t("I18N_ERR_Max_len_code") + 100);
    } else if (uiAppAttrs.name !== origUiAppAttrs.name) {
      validateName();
    } else {
      validateOtherFields();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-apps?name=" + uiAppAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg_GenInfo(t("I18N_ERR_Dup_ui_app_name"));
        } else {
          validateOtherFields();
        }

        return;
      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_GenInfo(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if (!uiAppAttrs.description || uiAppAttrs.description.trim().length === 0) {
      setErrMsg_GenInfo(t("I18N_ERR_Need_description"));
    } else if (uiAppAttrs.description.length > 250) {
      setErrMsg_GenInfo(t("I18N_ERR_Max_len_desc") + 250);
    } else if (uiAppAttrs.interface === '') {
      setErrMsg_GenInfo(t("I18N_ERR_Need_interface"));
    } else if (uiAppAttrs.interface.length > 20) {
      setErrMsg_GenInfo(t("I18N_ERR_Max_len_interface") + 20);
    } else if (uiAppAttrs.product === '') {
      setErrMsg_GenInfo(t("I18N_ERR_Need_product"));
    } else if (uiAppAttrs.product.length > 20) {
      setErrMsg_GenInfo(t("I18N_ERR_Max_len_product") + 20);
    } else {
      setErrMsg_GenInfo('');
      updateUiApp();
    }

  }

  const updateUiApp = () => {

    // Make a deep copy of uiAppAttrs to reqBody
    let reqBody = JSON.parse (JSON.stringify(uiAppAttrs));

    // Remove formatting (newline, space, etc) from the site map JSON.
    if (uiAppAttrs.sitemap && (uiAppAttrs.sitemap.length > 0)) {
      const tempString = uiAppAttrs.sitemap;
      const formatRemoved = tempString.replace(/(\r\n|\n|\r|\s)/gm, "");

      reqBody.sitemap = formatRemoved;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.put("ui-apps/" + uiAppAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore Ui to viewing mode
          setEditModeGeneralInfo(false);
          fetchUiApp(uiAppAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_GenInfo(t(translateAPIError(error)));
        }
      }
    });
  }


  const fetchUiApp = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("ui-apps/" + id);

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {
          setUiAppAttrWithFormatting (res.data[0]);
        }

        setErrMsg_GenInfo('');
      } catch (error) {
        setErrMsg_GenInfo(t(translateAPIError(error)));
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }

/*
  function renderScreen(screen, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "15%"}}><span style={{cursor:'pointer', color:'SteelBlue'}}
            onClick={() => handleScreenSelect(screen)}>{screen.name}</span></td>
        <td style={{width: "15%"}}>{screen.description}</td>
        <td style={{width: "23%"}}>{screen.path}</td>
        <td style={{width: "14%"}}>{screen.parentName}</td>
        <td style={{width: "5%"}}>{screen.show3dModel  === 1 ? <span>&#10003;</span> : ''}</td>
        <td style={{width: "5%"}}>{screen.showScopeSel === 1 ? <span>&#10003;</span> : ''}</td>
        <td style={{width: "5%"}}>{screen.showPlayback === 1 ? <span>&#10003;</span> : ''}</td>
        <td style={{width: "5%"}}>{screen.orderNum}</td>
        <td style={{width: "7%"}}>{t("I18N_" + screen.status)}</td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-edit_screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_screen")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleScreenEdit(screen)}><BiPencil size={16} />
            </span>
          </OverlayTrigger>
        </td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-remove-screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_screen")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleScreenDelete(screen)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }

  function renderSection(section, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "20%"}}><span style={{cursor:'pointer', color:'SteelBlue'}}
            onClick={() => handleSectionSelect(section)}>{section.name}</span></td>
        <td style={{width: "62%"}}>{section.description}</td>
        <td style={{width: "5%"}}>{section.orderNum}</td>
        <td style={{width: "7%"}}>{t("I18N_" + section.status)}</td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-edit-section" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_section")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleSectionEdit(section)}><BiPencil size={16} />
            </span>
          </OverlayTrigger>
        </td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-remove-section" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_section")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleSectionDelete(section)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }

  function renderElement(element, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "20%"}}><span style={{cursor:'pointer', color:'SteelBlue'}}
            onClick={() => handleElementEdit(element)}>{element.name}</span></td>
        <td style={{width: "30%"}}>{element.description}</td>
        <td style={{width: "32%"}}>{element.compName}</td>
        <td style={{width: "5%"}}>{element.orderNum}</td>
        <td style={{width: "7%"}}>{t("I18N_" + element.status)}</td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-edit-element" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_element")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleElementEdit(element)}><BiPencil size={16} />
            </span>
          </OverlayTrigger>
        </td>
        <td style={{width: "3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-remove-element" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_element")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleElementDelete(element)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }
*/


  function renderComp(comp, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{comp.name}</td>
        <td>{comp.description}</td>
        <td>
          <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }} onClick={() => handleCompSelect(comp)}>
            {t("I18N_Select")}
          </Button>
        </td>
      </tr>
    )
  }

  // -- END --

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_UiApp_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_UiApp_info")}
            </span>
            {editModeGeneralInfo ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editModeGeneralInfo ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}: *</Col>
                  <Col>{t("I18N_Description")}: *</Col>
                  <Col>{t("I18N_UiApp_Interface_type")}: *</Col>
                  <Col>{t("I18N_Product")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={uiAppAttrs.name} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={uiAppAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
{/*
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="interface"
                           value={uiAppAttrs.interface} onChange={(e) => onAttrsInputChange(e)} />
*/}
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!uiAppAttrs.interface ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (interfaceOptions.find( ({ key }) => key === uiAppAttrs.interface )).value) }
                      onSelect={onInterfaceSelect}>
                      {interfaceOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
                    {uiAppAttrs.product}
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_GenInfo}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Name")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_UiApp_Interface_type")}:</Col>
                <Col>{t("I18N_Product")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{uiAppAttrs.name}</Col>
                <Col style={{maxHeight:'80px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {uiAppAttrs.description}
                </Col>
                <Col>{t("I18N_" + uiAppAttrs.interface)}</Col>
                <Col>{uiAppAttrs.product}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{uiAppAttrs.creatorUsername}</Col>
                <Col>{formatDate(uiAppAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{uiAppAttrs.updaterUsername}</Col>
                <Col>{formatDate(uiAppAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            { (tabMode === 'ELEMENTS_TAB') ?
                <>
                  <span>
                    <BiCategoryAlt size={16} /> {t("I18N_UiElements")}
                  </span>
                  <span style={{marginLeft:'10px', marginRight:'10px'}}>
                    {'|'}
                  </span>
                  <span style={{fontSize:'12px', marginTop:'2px', color:'SteelBlue', cursor:'pointer'}} onClick={() => handleTargetToggle('SITEMAP_TAB')}>
                    <BiSitemap size={16} /> {t("I18N_Sitemap")}
                  </span>
                </>
              : (tabMode === 'SITEMAP_TAB') ?
                <>
                  <span style={{fontSize:'12px', marginTop:'2px', color:'SteelBlue', cursor:'pointer'}} onClick={() => handleTargetToggle('ELEMENTS_TAB')}>
                    <BiCategoryAlt size={16} /> {t("I18N_UiElements")}
                  </span>
                  <span style={{marginLeft:'10px', marginRight:'10px'}}>
                    {'|'}
                  </span>
                  <span>
                    <BiSitemap size={16} /> {t("I18N_Sitemap")}
                  </span>
                </>
              :
                <></>
            }

            <span className={classes.admin_pages__field_label} style={{marginLeft:'30px',marginTop:'3px', fontStyle:'italic', color:'Green'}}>
              {t("I18N_TIP_Scroll")}
            </span>
          </div>

          <hr className="solid" style={{ marginTop: '3px' }}></hr>

          { (tabMode === 'SITEMAP_TAB') ?
            <form>
              <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea readOnly rows={25} className={classes.admin_pages__field_editable} style={{minWidth: '100%' }}
                              onChange={() => {}} name="sitemap" value={sitemapDisplay} />
                  </Col>
                </Row>
              </div>
            </form>

          : (tabMode === 'ELEMENTS_TAB') ?
            <div style={{overflow:'auto'}}>
              <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
                <div style={{display:'flex'}}>
                  <span>
                    {t("I18N_Screens")}
                  </span>
                  { screenList ?
                    <>
                      <span style={{marginLeft:'20px', marginTop:'3px', fontSize:'11px'}}>
                        {t("I18N_Path")}:
                      </span>
                      <span style={{marginLeft:'5px', marginTop:'3px', fontSize:'11px', fontStyle:'italic'}}>
                        {uiAppAttrs.name}
                      </span>
                    </>
                  :
                    <></>
                  }
                  <span style={{marginLeft:'auto', marginRight:'30px'}}>
                    <OverlayTrigger overlay={<Tooltip id="tooltip-new_screen" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_screen")}</Tooltip>}>
                      <span onClick={handleScreenAdd}
                            style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                        <BiPlus size={18} />
                      </span>
                    </OverlayTrigger>
                  </span>
                </div>

                <div style={{fontSize:'11px'}} >
{/*
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Path")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Parent_menu")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Show_3d_model")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Show_scope_sel")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Show_playback")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Order_num")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Status")}</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(screenList && screenList.length > 0) ? screenList.map(renderScreen) : null}
                    </tbody>
                  </Table>
*/}

                  { screenList && screenList.length > 0 ?
                    <DataTable
                      columns={columnsScreens}
                      data={screenList}
                      customStyles={customStyles}
                      fixedHeader
                      fixedHeaderScrollHeight={'200px'}
                    />
                  : null
                  }
                </div>
              </div>

              <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
                <div style={{display:'flex'}}>
                  <span>
                    {t("I18N_Sections")}
                  </span>
                  { sectionList ?
                    <>
                      <span style={{marginLeft:'20px', marginTop:'3px', fontSize:'11px'}}>
                        {t("I18N_Path")}:
                      </span>
                      <span style={{marginLeft:'5px', marginTop:'3px', fontSize:'11px', fontStyle:'italic'}}>
                        {uiAppAttrs.name} {selectedScreen ? ' > ' + selectedScreen.name : ''}
                      </span>
                    </>
                  :
                    <></>
                  }
                  { selectedScreen ?
                    <span style={{marginLeft:'auto', marginRight:'30px'}}>
                      <OverlayTrigger overlay={<Tooltip id="tooltip-new_section" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_section")}</Tooltip>}>
                        <span onClick={handleSectionAdd}
                              style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <BiPlus size={18} />
                        </span>
                      </OverlayTrigger>
                    </span>
                  :
                    <></>
                  }
                </div>

                <div style={{overflow:'auto', fontSize:'11px', maxHeight:'100px'}}>
                  {(selectedScreen) ?
/*
                    <Table hover responsive size="sm">
                      <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                        <tr>
                          <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Order_num")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Status")}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(sectionList && sectionList.length > 0) ?  sectionList.map(renderSection) : null }
                      </tbody>
                    </Table>
*/

                    ( sectionList && sectionList.length > 0 ?
                      <DataTable
                        columns={columnsSections}
                        data={sectionList}
                        customStyles={customStyles}
                        fixedHeader
                        fixedHeaderScrollHeight={'100px'}
                      />
                    : null
                    )
                  :
                    <span style={{marginLeft:'5px', marginTop:'10px', fontWeight:'300', fontStyle:'italic'}} >
                      {t("I18N_Select_screen_first")}
                    </span>
                  }
                </div>
              </div>

              <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
                <div style={{display:'flex'}}>
                  <span>
                    {t("I18N_Elements")}
                  </span>
                  { elementList ?
                    <>
                      <span style={{marginLeft:'20px', marginTop:'3px', fontSize:'11px'}}>
                        {t("I18N_Path")}:
                      </span>
                      <span style={{marginLeft:'5px', marginTop:'3px', fontSize:'11px', fontStyle:'italic'}}>
                        {uiAppAttrs.name} {selectedScreen ? ' > ' + selectedScreen.name : ''}  {selectedSection ? ' > ' + selectedSection.name : ''}
                      </span>
                    </>
                  :
                    <></>
                  }
                  { selectedSection ?
                    <span style={{marginLeft:'auto', marginRight:'30px'}}>
                      <OverlayTrigger overlay={<Tooltip id="tooltip-new_element" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_element")}</Tooltip>}>
                        <span onClick={handleElementAdd}
                              style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <BiPlus size={18} />
                        </span>
                      </OverlayTrigger>
                    </span>
                  :
                    <></>
                  }
                </div>

                <div style={{overflow:'auto', fontSize:'11px', maxHeight:'100px'}}>
                  {(selectedSection) ?
/*
                    <Table hover responsive size="sm">
                      <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                        <tr>
                          <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_UiComp")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Order_num")}</th>
                          <th style={{fontWeight:'400'}}>{t("I18N_Status")}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {(elementList && elementList.length > 0) ? elementList.map(renderElement) : null}
                      </tbody>
                    </Table>
*/
                    ( elementList && elementList.length > 0 ?
                      <DataTable
                        columns={columnsElements}
                        data={elementList}
                        customStyles={customStyles}
                        fixedHeader
                        fixedHeaderScrollHeight={'100px'}
                      />
                    : null
                    )
                  :
                    <span style={{marginLeft:'5px', marginTop:'10px', fontWeight:'300', fontStyle:'italic'}} >
                      {t("I18N_Select_section_first")}
                    </span>
                  }
                </div>
              </div>

            </div>
          :
            <></>
          }
        </div>

        <hr className="solid" style={{ marginTop: '10px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mt-1">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-1"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top', marginLeft: '20px' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


        {/* ----- Screen Dialogs ----- */}

        <Modal show={showScreenAddDialog} onHide={handleScreenAddCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Screen_info")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={newScreen ? newScreen.name : ''} onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Description")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={newScreen ? newScreen.description : ''} onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Parent_menu")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!newScreen.parentId ? t("common:I18N_No_parent_menu") : newScreen.parentName}
                      onSelect={onAddParentSelect}>
{/*
                      {screenList.filter(function(screen){ return screen.parentId == null;}).map((item, index) => {
*/}
                      {parentMenuList.map((item, index) => {
                        return (
                          <Dropdown.Item key={item.id} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.id ? item.name : t("common:I18N_No_parent_menu")}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Path")}: {((newScreen.parentId && (newScreen.parentId.length > 0)) ? '*' : '')}</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="path"
                           value={newScreen ? newScreen.path : ''} onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'15px'}}>
                  <Col><Form.Check type="switch" name={"show3dModel"} label={(t("I18N_Show_3d_model"))}
                        checked={(newScreen.show3dModel === 1)} onChange={onCheckboxSelectNew} /></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'6px'}}>
                  <Col><Form.Check type="switch" name={"showScopeSel"} label={(t("I18N_Show_scope_selector"))}
                        checked={(newScreen.showScopeSel === 1)} onChange={onCheckboxSelectNew} /></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'6px'}}>
                  <Col><Form.Check type="switch" name={"showPlayback"} label={(t("I18N_Show_playback_ctrl"))}
                        checked={(newScreen.showPlayback === 1)} onChange={onCheckboxSelectNew} /></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Floor_list")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px'}} name="floorListDisplay"
                              value={(newScreen.floorListDisplay != null) ? newScreen.floorListDisplay : ''}
                              onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Layer_list")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px'}} name="layerListDisplay"
                              value={(newScreen.layerListDisplay !== null) ? newScreen.layerListDisplay : ''}
                              onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Order_num")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="orderNum"
                           value={newScreen ? newScreen.orderNum : ''} onChange={(e) => onScreenAddInputChange(e)} />
                  </Col>
                </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Controlling_permission")}:</Col>
                  </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="permCode" value={newScreen.permCode}
                           />
                        <span onClick={event => handlePermPicker(event, 'NEW')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                        <span onClick={event => handleClearPermPicker(event, 'NEW')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <XIcon size={14} />
                        </span>
                    </Col>
                  </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!newScreen.status ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === newScreen.status )).value)}
                      onSelect={onStatusSelectScreenNew}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_ScreenAdd}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleScreenAddCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleScreenAddSubmit}>
                      {t("I18N_Submit")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showScreenEditDialog} onHide={handleScreenEditCancel} centered >
          <Modal.Body>
            { targetScreen ?
              <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
                <span>
                  {t("I18N_Edit_Screen_Info")}
                </span>

                <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <form>
                  <Row className={classes.admin_pages__field_label}>
                    <Col>{t("I18N_Name")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                             value={targetScreen ? targetScreen.name : ''} onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Description")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                                value={targetScreen ? targetScreen.description : ''} onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Parent_menu")}:</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={!targetScreen.parentId ? t("common:I18N_No_parent_menu") : targetScreen.parentName}
                        onSelect={onEditParentSelect}>
{/*
                        {screenList.filter(function(screen){ return screen.parentId == null;}).map((item, index) => {
*/}
                        {parentMenuList.map((item, index) => {
                          return (
                            <Dropdown.Item key={item.id} eventKey={item.id} className={classes.dropdown_item_wrap}>
                              {item.id ? item.name : t("common:I18N_No_parent_menu")}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Path")}: {((targetScreen.parentId && (targetScreen.parentId.length > 0)) ? '*' : '')}</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="path"
                             value={targetScreen ? targetScreen.path : ''} onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'15px'}}>
                    <Col><Form.Check type="switch" name={"show3dModel"} label={(t("I18N_Show_3d_model"))}
                          checked={(targetScreen.show3dModel === 1)} onChange={onCheckboxSelectEdit} /></Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'6px'}}>
                    <Col><Form.Check type="switch" name={"showScopeSel"} label={(t("I18N_Show_scope_selector"))}
                          checked={(targetScreen.showScopeSel === 1)} onChange={onCheckboxSelectEdit} /></Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'6px'}}>
                    <Col><Form.Check type="switch" name={"showPlayback"} label={(t("I18N_Show_playback_ctrl"))}
                          checked={(targetScreen.showPlayback === 1)} onChange={onCheckboxSelectEdit} /></Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Floor_list")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px'}} name="floorListDisplay"
                                value={(targetScreen.floorListDisplay != null) ? targetScreen.floorListDisplay : ''}
                                onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Layer_list")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'100px'}} name="layerListDisplay"
                                value={(targetScreen.layerListDisplay !== null) ? targetScreen.layerListDisplay : ''}
                                onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Order_num")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="orderNum"
                             value={targetScreen ? targetScreen.orderNum : ''} onChange={(e) => onScreenEditInputChange(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Controlling_permission")}:</Col>
                  </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="permCode" value={targetScreen.permCode}
                           />
			<span onClick={event => handlePermPicker(event, 'EDIT')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                        <span onClick={event => handleClearPermPicker(event, 'EDIT')} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <XIcon size={14} />
                        </span>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                    <Col>{t("I18N_Status")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={!targetScreen.status ? t("common:I18N_DROPDOWN_PROMPT") :
                                t("I18N_" + (statusOptions.find( ({ key }) => key === targetScreen.status )).value)}
                        onSelect={onStatusSelectScreenEdit}>
                        {statusOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                    <span>{t("I18N_Req_fields")}</span>
                  </Row>

                  <Row>
                    <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_ScreenEdit}
                    </span>
                  </Row>
                  <Row>
                    <div display='flex' style={{marginTop:'15px'}}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ float: 'left' }}
                        onClick={handleScreenEditCancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ marginLeft: '15px' }}
                        onClick={handleScreenEditSubmit}>
                        {t("I18N_Save")}
                      </Button>
                    </div>
                  </Row>
                </form>
              </div>
            :
              <></>
            }
          </Modal.Body>
        </Modal>


        <Modal show={showScreenDeleteDialog} onHide={handleScreenDeleteCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {t("I18N_Screen_delete_confirm")}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic'}}>
                {targetScreen ? targetScreen.name : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_ScreenDelete}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={handleScreenDeleteCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={handleScreenDeleteSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>


        {/* ----- Section Dialogs ----- */}

        <Modal show={showSectionAddDialog} onHide={handleSectionAddCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Section_info")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={newSection ? newSection.name : ''} onChange={(e) => onSectionAddInputChange(e)} />
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Description")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={newSection ? newSection.description : ''} onChange={(e) => onSectionAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Order_num")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="orderNum"
                           value={newSection ? newSection.orderNum : ''} onChange={(e) => onSectionAddInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!newSection.status ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === newSection.status )).value)}
                      onSelect={onStatusSelectSectionNew}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_SectionAdd}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleSectionAddCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleSectionAddSubmit}>
                      {t("I18N_Submit")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showSectionEditDialog} onHide={handleSectionEditCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Edit_Section_Info")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={targetSection ? targetSection.name : ''} onChange={(e) => onSectionEditInputChange(e)} />
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Description")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={targetSection ? targetSection.description : ''} onChange={(e) => onSectionEditInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Order_num")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="orderNum"
                           value={targetSection ? targetSection.orderNum : ''} onChange={(e) => onSectionEditInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={(!targetSection || !targetSection.status) ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === targetSection.status )).value)}
                      onSelect={onStatusSelectSectionEdit}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_SectionEdit}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleSectionEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleSectionEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>


        <Modal show={showSectionDeleteDialog} onHide={handleSectionDeleteCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {t("I18N_Section_delete_confirm")}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic'}}>
                {targetSection ? targetSection.name : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_SectionDelete}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={handleSectionDeleteCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={handleSectionDeleteSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>


        {/* ----- Element Dialogs ----- */}

        <Modal show={showElementAddDialog || showElementEditDialog} onHide={handleElementAddCancel} centered >
          <Modal.Body style={{height:'600px', overflow:'auto'}}>
            <div className={classes.admin_pages__page_subtitle} >
              <span>
                {t("I18N_Element_info")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Container>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Name")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={showElementAddDialog ? (newElement ? newElement.name : '') : (targetElement ? targetElement.name : '')}
                           onChange={(e) => showElementAddDialog ? onElementAddInputChange(e) : onElementEditInputChange(e)} />
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Description")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={showElementAddDialog ? (newElement ? newElement.description : '') : (targetElement ? targetElement.description : '')}
                              onChange={(e) => showElementAddDialog ? onElementAddInputChange(e) : onElementEditInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>
                    <span>{t("I18N_UiComp")}: *</span>
                    { !compShowSelector ?
                      <OverlayTrigger overlay={<Tooltip id="tooltip-search_comp" style={{fontSize:'11px'}}>{t("I18N_TIP_Comp_search")}</Tooltip>}>
                        <span onClick={handleCompSearchOpen} style={{ marginLeft:'10px', color:'SteelBlue', cursor:'pointer'}}>
                              <BiLink size={14} />
                        </span>
                      </OverlayTrigger>
                    :
                      <></>
                    }
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_label}>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                           value={showElementAddDialog ? (newElement ? newElement.compName : '') : (targetElement ? targetElement.compName : '')} onChange={() => {}} />
                  </Col>
                </Row>

                { compShowSelector ?
                  <Card style={{marginTop:'10px', padding:'5px', border:'none', backgroundColor:'rgb(240,240,240)'}}>
                    <Row style={{marginTop:'5px'}}>
                      <div style={{ display: 'flex' }}>
                        <span style={{ marginLeft: '0px', marginRight: 'auto', width: '220px' }}>
                          <Form onSubmit={handleSearchCompSubmit}>
                            <Row>
                              <Col sm="10" style={{ marginRight: '0px', paddingRight: '0px' }}>
                                <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerm" value={searchTerm}
                                              onChange={(e) => onSearchInputChange(e)} placeholder={t("I18N_Search_uiComp")} />
                              </Col>
                              <Col sm="1" style={{ paddingTop: '5px' }}>
                                <OverlayTrigger overlay={<Tooltip id="tooltip-search_comp" style={{fontSize:'11px'}}>
                                                         {t("I18N_TIP_Search_UI_comp")}</Tooltip>}>
                                  <span onClick={handleSearchCompSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                                    <BiSearch size={18} />
                                  </span>
                                </OverlayTrigger>
                              </Col>
                            </Row>
                          </Form>
                        </span>
                        <span onClick={handleCompSearchClose} style={{ marginRight:'5px', paddingTop:'0px', cursor: 'pointer' }}>
                           <BiX size={20} />
                        </span>
                      </div>
                    </Row>

                    <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
                      <Table hover responsive size="sm">
                        <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                          <tr>
                            <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                            <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(compList && compList.length > 0) ? compList.map(renderComp) : null}
                        </tbody>
                      </Table>
                    </div>
                  </Card>
                :
                  <>
                  </>
                }

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Comp_config")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="compConfigDisplay"
                              value={showElementAddDialog ? (newElement ? newElement.compConfigDisplay : '') : (targetElement ? targetElement.compConfigDisplay : '')}
                              onChange={(e) => showElementAddDialog ? onElementAddInputChange(e) : onElementEditInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Order_num")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="orderNum"
                           value={showElementAddDialog ? (newElement ? newElement.orderNum : '') : (targetElement ? targetElement.orderNum : '')}
                           onChange={(e) => showElementAddDialog ? onElementAddInputChange(e) : onElementEditInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px'}}>
                  <Col>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    {showElementAddDialog ?
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={(!newElement || !newElement.status) ? t("common:I18N_DROPDOWN_PROMPT") :
                                t("I18N_" + (statusOptions.find( ({ key }) => key === newElement.status )).value)}
                        onSelect={onStatusSelectElementNew}>
                        {statusOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    :
                      <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={(!targetElement || !targetElement.status) ? t("common:I18N_DROPDOWN_PROMPT") :
                                t("I18N_" + (statusOptions.find( ({ key }) => key === targetElement.status )).value)}
                        onSelect={onStatusSelectElementEdit}>
                        {statusOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("I18N_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    }
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'20px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_ElementAddOrEdit}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={showElementAddDialog ? handleElementAddCancel : handleElementEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={showElementAddDialog ? handleElementAddSubmit : handleElementEditSubmit}>
                      {t("I18N_Submit")}
                    </Button>
                  </div>
                </Row>
              </Container>
            </div>
          </Modal.Body>
        </Modal>


        <Modal show={showElementDeleteDialog} onHide={handleElementDeleteCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {t("I18N_Element_delete_confirm")}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic'}}>
                {targetElement ? targetElement.name : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_ElementDelete}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={handleElementDeleteCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={handleElementDeleteSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showPermPickerDialog} onHide={handlePermPickerClose} centered >
          <Modal.Body style={{height:'500px', overflow:'auto', border:'5px solid rgba(125,255,255,0.3)'}}>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Permissions")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th style={{fontWeight:'400'}}>{t("I18N_Perm_code")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {permList? permList.map(renderPermPicker) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handlePermPickerClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {permPickerErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}

export default UiAppAdminDetailsView;
